import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  margin: 0 auto;
  width: 100%;

  ${media.moreThan('480px')`
    width: 55%;
  `};

  > button {
    display: block;
    width: 100%;
  }
`;
